import type { FlowExecution, InstanceStatus } from "@skaile/workspaces/types";

/**
 * Mirror an instance's flow execution into the instance status.
 * Terminal flow statuses win; gate nodes surface next (approval before
 * input); `paused` is not expected inside an instance (pausing is a
 * group-level concept) and is treated as live.
 */
export function deriveInstanceStatus(flow: FlowExecution): InstanceStatus {
  if (flow.status === "complete" || flow.status === "failed" || flow.status === "cancelled") {
    return flow.status;
  }
  const nodes = Object.values(flow.nodes);
  if (nodes.some((n) => n.status === "awaiting_approval")) return "awaiting_approval";
  if (nodes.some((n) => n.status === "awaiting_input")) return "awaiting_input";
  return "running";
}
